import React from 'react';
import { disabledOption } from '../utils';
import MultiSelectFilter from './MultiSelectFilter';
import useCFFilters from './useCFFilters';
var DegreeCFFilter = function (props) {
    var _a = useCFFilters({}), getDegreeOptions = _a.getDegreeOptions, degreeValues = _a.degreeValues;
    var options = getDegreeOptions(props.degreeData);
    return (React.createElement(MultiSelectFilter, { label: "Degree", options: options, getOptionDisabled: disabledOption, onApply: function (values) {
            props === null || props === void 0 ? void 0 : props.handleFilterApply({ name: props === null || props === void 0 ? void 0 : props.name, value: values });
        }, values: degreeValues }));
};
export default DegreeCFFilter;
//# sourceMappingURL=DegreeCFFilter.js.map